(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edenpure-family-parts"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initFamilyFinder() {

    const section = document.querySelector('.ep-family-parts');

    if (!section || section.dataset.finderReady === 'true') {
      return;
    }

    section.dataset.finderReady = 'true';

    const form = section.querySelector('#ep-family-search-form');
    const input = section.querySelector('#ep-family-search-input');
    const message = section.querySelector('#ep-family-search-message');

    if (!form || !input || !message) {
      return;
    }

    const records = Array.from(
      section.querySelectorAll('.ep-family-record')
    ).map(function(record) {

      return {
        name: record.dataset.name || '',
        primary: record.dataset.primary || '',
        alternates: (record.dataset.alternates || '')
          .split('|||')
          .filter(Boolean),
        aliases: (record.dataset.aliases || '')
          .split('|||')
          .filter(Boolean),
        url: record.dataset.url || ''
      };

    });


    function normalize(value) {

      return String(value || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');

    }


    function searchableValues(record) {

      return [
        record.name,
        record.primary,
        ...record.alternates,
        ...record.aliases
      ]
      .map(normalize)
      .filter(Boolean);

    }


    form.addEventListener('submit', function(event) {

      event.preventDefault();

      message.textContent = '';

      const query = normalize(input.value);

      if (!query) {

        message.textContent =
          'Enter a model number or model name.';

        input.focus();
        return;

      }


      const exactMatches = records.filter(function(record) {

        return searchableValues(record).includes(query);

      });


      if (exactMatches.length === 1) {

        window.location.href = exactMatches[0].url;
        return;

      }


      const partialMatches = records.filter(function(record) {

        return searchableValues(record).some(function(value) {
          return value.includes(query);
        });

      });


      if (partialMatches.length === 1) {

        window.location.href = partialMatches[0].url;
        return;

      }


      if (partialMatches.length > 1) {

        message.textContent =
          'More than one model matches. Please enter the complete model number.';

        return;

      }


      message.textContent =
        "We couldn't match that model. Check the model number on your EdenPURE product label.";

    });

  }


  document.addEventListener(
    'DOMContentLoaded',
    initFamilyFinder
  );


  document.addEventListener(
    'shopify:section:load',
    initFamilyFinder
  );


  initFamilyFinder();

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edenpure-model-finder"] && !Shopify.designMode) return;
  try {
    

  function initializeEdenPUREModelFinders() {

    document.querySelectorAll('[data-ep-model-finder]').forEach(function (finder) {

      if (finder.dataset.initialized === 'true') {
        return;
      }

      finder.dataset.initialized = 'true';

      const form = finder.querySelector('[data-model-finder-form]');
      const input = finder.querySelector('[data-model-finder-input]');
      const message = finder.querySelector('[data-model-finder-message]');

      if (!form || !input || !message) {
        return;
      }

      const records = Array.from(
        finder.querySelectorAll('.ep-model-record')
      ).map(function (record) {

        return {
          name: record.dataset.name || '',
          primary: record.dataset.primary || '',
          alternates: (record.dataset.alternates || '')
            .split('|||')
            .filter(Boolean),
          aliases: (record.dataset.aliases || '')
            .split('|||')
            .filter(Boolean),
          url: record.dataset.url || ''
        };

      });

      function normalize(value) {

        return String(value || '')
          .toUpperCase()
          .replace(/[^A-Z0-9]/g, '');

      }

      function searchableValues(record) {

        return [
          record.name,
          record.primary,
          ...record.alternates,
          ...record.aliases
        ]
          .map(normalize)
          .filter(Boolean);

      }

      function showError(text) {

        message.textContent = text;
        message.classList.add('ep-model-finder__message--error');

      }

      function clearMessage() {

        message.textContent = '';
        message.classList.remove('ep-model-finder__message--error');

      }

      form.addEventListener('submit', function (event) {

        event.preventDefault();

        clearMessage();

        const query = normalize(input.value);

        if (!query) {

          showError('Enter a model number or model name.');
          input.focus();
          return;

        }

        const exactMatches = records.filter(function (record) {

          return searchableValues(record).includes(query);

        });

        if (exactMatches.length === 1) {

          window.location.href = exactMatches[0].url;
          return;

        }

        if (exactMatches.length > 1) {

          showError(
            'More than one model matches that entry. Please enter the complete model number.'
          );

          return;

        }

        const partialMatches = records.filter(function (record) {

          return searchableValues(record).some(function (value) {
            return value.includes(query);
          });

        });

        if (partialMatches.length === 1) {

          window.location.href = partialMatches[0].url;
          return;

        }

        if (partialMatches.length > 1) {

          showError(
            'We found more than one possible model. Please enter the complete model number.'
          );

          return;

        }

        showError(
          "We couldn't match that model. Check the model number on your EdenPURE product label."
        );

      });

    });

  }

  document.addEventListener(
    'DOMContentLoaded',
    initializeEdenPUREModelFinders
  );

  document.addEventListener(
    'shopify:section:load',
    initializeEdenPUREModelFinders
  );

  initializeEdenPUREModelFinders();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edenpure-part-type"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initializePartTypeFinder() {

    const section =
      document.getElementById('ep-part-type-page');

    if (!section || section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';

    const form =
      section.querySelector('#ep-part-type-finder-form');

    const input =
      section.querySelector('#ep-part-type-finder-input');

    const message =
      section.querySelector('#ep-part-type-finder-message');

    const results =
      section.querySelector('#ep-part-type-finder-results');

    if (!form || !input || !message || !results) {
      return;
    }


    const records = Array.from(
      section.querySelectorAll('.ep-part-type-record')
    ).map(function(record) {

      return {
        productTitle: record.dataset.productTitle || '',
        productUrl: record.dataset.productUrl || '',
        modelName: record.dataset.modelName || '',
        primary: record.dataset.primary || '',
        alternates: (record.dataset.alternates || '')
          .split('|||')
          .filter(Boolean),
        aliases: (record.dataset.aliases || '')
          .split('|||')
          .filter(Boolean)
      };

    });


    function normalize(value) {

      return String(value || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g,'');

    }


    function searchableValues(record) {

      return [
        record.modelName,
        record.primary,
        ...record.alternates,
        ...record.aliases
      ]
      .map(normalize)
      .filter(Boolean);

    }


    form.addEventListener('submit', function(event) {

      event.preventDefault();

      message.textContent = '';
      results.innerHTML = '';

      const query = normalize(input.value);

      if (!query) {

        message.textContent =
          'Enter a model number or model name.';

        input.focus();
        return;

      }


      let matches = records.filter(function(record) {

        return searchableValues(record).includes(query);

      });


      if (!matches.length) {

        matches = records.filter(function(record) {

          return searchableValues(record).some(function(value) {
            return value.includes(query);
          });

        });

      }


      const uniqueProducts = [];

      matches.forEach(function(match) {

        const alreadyAdded = uniqueProducts.some(function(product) {
          return product.productUrl === match.productUrl;
        });

        if (!alreadyAdded) {
          uniqueProducts.push(match);
        }

      });


      if (!uniqueProducts.length) {

        message.textContent =
          "We couldn't find a compatible part in this category for that model.";

        return;

      }


      message.textContent =
        uniqueProducts.length === 1
          ? 'We found 1 compatible part:'
          : 'We found ' + uniqueProducts.length + ' compatible parts:';


      uniqueProducts.forEach(function(product) {

        const link = document.createElement('a');

        link.href = product.productUrl;
        link.className = 'ep-part-type-result';
        link.textContent = product.productTitle + ' →';

        results.appendChild(link);

      });

    });

  }


  document.addEventListener(
    'DOMContentLoaded',
    initializePartTypeFinder
  );

  document.addEventListener(
    'shopify:section:load',
    initializePartTypeFinder
  );

  initializePartTypeFinder();

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
